import React from 'react'

export default function Breadcrumbs(props) {
  const { crumbs = [], ...rest } = props

  return (
    <div
      {...rest}
      className={[
        'text-xs',
        rest.className
      ]}
    >
      {crumbs.map((crumb, index) => (
        <span key={index}>
          {crumb.url ? (
            <span className="text-gray-600">
              <a href={crumb.url} className="hover:underline">
                {crumb.text}
              </a>
              <span className="px-2">
                >
              </span>
            </span>
          ) : (
            <span>{crumb.text}</span>
          )}
        </span>
      ))}
    </div>
  )
}
